import { ApiError } from './ApiError';

export class ConflictError extends ApiError {
  constructor(message: string, errors: unknown[] = []) {
    super(409, message, errors);
    this.name = 'ConflictError';
  }
}
